import { NgModule } from '@angular/core';
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { isAppInitialized } from '@core/bootstrap/bootstrap.guard';
import { RsvpCanActivateFn } from '@app/rsvp/rsvp.guard';

const rsvpModule = () => import('./rsvp/rsvp.module').then((x) => x.RsvpModule);
const venueModule = () => import('./venue/venue.module').then((x) => x.VenueModule);

const checkoutChildRoutes: Routes = [
  { path: '', loadChildren: venueModule },
  { path: 'rsvp/:id', loadChildren: rsvpModule, canActivate: [RsvpCanActivateFn] }
];

const errorPaths = ['404', 'error', 'error-storage', 'maintenance'];
const errorRoutes = errorPaths.map((path) => ({
  path,
  component: ErrorPageComponent
}));

const routes: Routes = [
  ...errorRoutes,
  {
    path: ':slug/:lang',
    data: { routeHasVenueSlug: false },
    canActivate: [isAppInitialized],
    children: checkoutChildRoutes
  },
  {
    path: ':venue/:slug/:lang',
    data: { routeHasVenueSlug: true },
    canActivate: [isAppInitialized],
    children: checkoutChildRoutes
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

const options: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, options)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
